import React from "react";
import { Link } from "react-router-dom";
import sitedata from "../sitedetails.json";
import { useSelector } from "react-redux";
const Navbar = () => {

  const { isAuthenticated, user} = useSelector((state) => state.user);

  
  return (
    <div className="w-full ">
      {/* max-w-[1512px] */}
      <div className=" h-[90px]  items-center max-h-[96px] text-white flex bg-black pl-20 pr-10 lg:px-[230px] justify-between">
        {/* <img src={sitedata.brand_logo} alt="Logo" width="80px" /> */}
        <Link to='/'><h1 className=" text-white text-lg font-semibold">{sitedata.brand_name}</h1></Link>

        <div className=" flex items-center">
          <Link to="/courses">
            <p className=" hidden md:block px-8 hover:text-brand_green ">Courses</p>
          </Link>
          <Link to="/blogs">
          <p className="hidden md:block  px-8 hover:text-brand_green ">Blogs</p>
          </Link>
          <Link to="/pricing">
          <p className="hidden md:block  px-8 hover:text-brand_green ">Get Access</p>
          </Link>

          <h1 className="">{!isAuthenticated ? <Link to="/login">
          <p className=" lg:mx-0 pl-20 pr-10  lg:px-8 hover:text-brand_green ">Login</p>
          </Link> : <Link to="/profile">
          <p className="lg:px-8 hover:text-brand_green "><img className="w-[30px] h-[30px] lg:mx-0  rounded-full overflow-hidden" src={user.avatar.url} alt="" /></p>
          </Link>}</h1>
          
        </div>
      </div>
    </div>
  );
};

export default Navbar;
